import { c as _c } from "react/compiler-runtime";
import NFTLeaderboard from "@/components/leaderboard/NFTLeaderboard";
import type { MemesExtendedData, NFT } from "@/entities/INFT";
import { MemeCollectorsStats } from "./MemePageLiveStats";
export function MemePageCollectorsSubMenu(props) {
  const $ = _c(9);
  if (props.show && props.nft) {
    let t0;
    if ($[0] !== props.nftMeta) {
      t0 = props.nftMeta && <div><MemeCollectorsStats nftMeta={props.nftMeta} /></div>;
      $[0] = props.nftMeta;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    let t1;
    if ($[2] !== props.nft.contract || $[3] !== props.nft.id) {
      t1 = <div className="tw-pt-3"><NFTLeaderboard contract={props.nft.contract} nftId={props.nft.id} /></div>;
      $[2] = props.nft.contract;
      $[3] = props.nft.id;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    let t2;
    if ($[5] !== t0 || $[6] !== t1) {
      t2 = <>{t0}{t1}</>;
      $[5] = t0;
      $[6] = t1;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    return t2;
  }
  let t0;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <></>;
    $[8] = t0;
  } else {
    t0 = $[8];
  }
  return t0;
}